import { useCallback, useState } from "react";
import type { GetProp, UploadFile, UploadProps } from 'antd';
import { BaseResponseType } from "@/types/message";
import { UploadChangeParam } from "antd/es/upload/interface";
import { UploadFileType, UseUpload } from "@/types/base";
import { deleteFile } from "@/api/questions";
import { changeSourceUrl } from "@/utils/common";



const useUpload = (props: UseUpload) => {
  const {
    singleSizeLimit = 5,
    uploadFileAction,
    fileRegex,
    initFile=[]
  } = props;

  const [fileList, setFileList] = useState<UploadFileType[]>([...initFile]);//文件列表
  const handleChange = useCallback(({ fileList: newFileList,file: newFile }: UploadChangeParam<UploadFile<any>>) => {
    console.log('handleChange', newFileList);
    /**
     * 1. 过滤没有status字段的文件
     * 2. 过滤文件大小
     * 3. 过滤文件类型
     */
    const updateFileList=newFileList.filter((file: any) =>file.status && file.size < singleSizeLimit * 1024 && (fileRegex?fileRegex?.test(file.type):true));

    setFileList((old)=>{
      return updateFileList.map((file: any) => {
        const oldFile = old.find((item: any) => item.uid === file.uid);
        if(oldFile){
          //处理多文件同时上传情况下出现的 上传进度条不消失问题
          return oldFile?.status!='uploading' ? { ...oldFile} : file;
        }
        return file;
      })
    });
  }, [])
  /**
     * 上传  
     */
  const uploadFileHandle = useCallback((data: any) => {
    console.log('上传图片', data);
    const { file, onProgress, onSuccess, onError } = data;
    onProgress({ percent: 0 });//设置上传进度
    const formData = new FormData();
    formData.append('file', file);
    uploadFileAction(formData, {
      onUploadProgress: (progressEvent: any) => {
        console.log('progressEvent', progressEvent);
        const { loaded, total } = progressEvent;
        const percent = Math.round((loaded * 100 / total));
        onProgress({ percent });
      }
    }).then((res: BaseResponseType<any>) => {
      console.log('上传成功', res);
      if (res.code == 200) {
        onSuccess(res.message);
        onProgress({ percent: 100 });
        setFileList(prev => prev.map(item =>
          item.uid === file.uid
            ? { ...item, status: 'done', percent: 100, url: changeSourceUrl(res.result.url), fileId: res.result.id }
            : item
        ));
      } else {
        onError(res?.message);
        setFileList(prev => prev.filter(item => item.uid !== file.uid));
        window.message.error(res?.message);
      }
    }).catch((err: any) => {
      console.log('上传失败', err);
      onProgress({ percent: 100 });
      onError(err);
      err?.message && window.message.error(err?.message);
      setFileList(prev => prev.filter(item => item.uid !== file.uid));
    })
  }, [])

  const onRemoveHandle=useCallback(
    /**
     * 删除事件处理
     * @param file 
     * @returns 
     */
    (file: UploadFileType):Promise<boolean> => {
    console.log('删除', file);
    return new Promise((resolve, reject) => {
      if(file.fileId==undefined){
        return resolve(false);
      }
      deleteFile(file.fileId).then((res) => {
        if (res.code == 200) {
          resolve(true);
        } else  {
          resolve(false);
          window.message.error(res?.message);
        }
      }).catch((err)=>{
        resolve(false);
        err?.message && window.message.error(err?.message);
      })
    })
  },[])
  const onDropHandle = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    console.log('onDrop', e);
  },[])
  return {
    fileList,
    setFileList,
    onRemoveHandle,
    onDropHandle,
    handleChange,
    uploadFileHandle
  }
}

export default useUpload;